import { GridOptions } from 'ag-grid-community'
import { useMemo } from 'react'
import { UserApiTokenRow } from '../UserApiTokenRow'
import { useColumnDefs } from './useColumnDefs'
import { DefaultCellRenderer } from '../../../containers/BulkSheetView/components/cellRenderer'
import { columnTypes } from '../../../containers/commons/AgGrid'

export const useGridOptions = (): GridOptions<UserApiTokenRow> => {
  const columnDefs = useColumnDefs()

  return useMemo(
    () => ({
      columnDefs,
      context: {},
      defaultColGroupDef: { suppressHeaderContextMenu: true },
      defaultColDef: {
        cellDataType: false,
        sortable: true,
        resizable: true,
        suppressHeaderMenuButton: true,
        suppressHeaderContextMenu: true,
        cellRenderer: DefaultCellRenderer,
      },
      rowHeight: 38,
      headerHeight: 38,
      cellSelection: true,
      rowSelection: {
        mode: 'singleRow',
        enableClickSelection: false,
      },
      getRowId: params => params.data.uuid,
      allowContextMenuWithControlKey: true,
      preventDefaultOnContextMenu: true,
      columnTypes: columnTypes(),
      processUnpinnedColumns: () => [],
    }),
    [columnDefs]
  )
}
